var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"current-events-list"}},[_vm._l((_vm.events),function(event,i){return [_c('EventListRow',{key:i,attrs:{"event":event.event,"member_event":event.member_event},on:{"select_event_clicked":_vm.select_event_clicked}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }